import type { Component } from "solid-js";
import type { IconProps } from "./types";

const TestingIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 16a9.065 9.065 0 0 1-6.23-.693L5 14.5m14.8.8a2.25 2.25 0 0 1-2.6 2.6c-1.312 0-2.5-.621-3.25-1.618A6.75 6.75 0 0 1 7.25 21a9.969 9.969 0 0 0 4.75-1.23"
      />
    </svg>
  );
};

export default TestingIcon;
